import { render } from "./DigitalTicketing.vue?vue&type=template&id=24dd41e9&scoped=true"
import script from "./DigitalTicketing.vue?vue&type=script&lang=js"
export * from "./DigitalTicketing.vue?vue&type=script&lang=js"

import "./DigitalTicketing.vue?vue&type=style&index=0&id=24dd41e9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24dd41e9"]])

export default __exports__